import { useCallback } from 'react';

import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';

import { useCompleteTask } from '../useCompleteTask';
import type { TaskType } from '../useCompleteTask/constants';
import { useNextStepsExperiment } from '../useNextStepsExperiment';

export function useAutoCheckOffTask() {
	const {
		data: { isEnabled: isNextStepsEnabled },
	} = useNextStepsExperiment();
	const {
		data: {
			petition: { activeTasks, allCompletedTasks },
		},
		actions: { refreshData },
	} = useStarterDashboardV2PageData();
	const { mutate: completeTask } = useCompleteTask({ completionType: 'automatic', version: 'new_12_2025' });

	const handleAutoCheckOffTask = useCallback(
		async (taskId: TaskType) => {
			if (isNextStepsEnabled) {
				if (
					activeTasks.__typename !== 'PetitionTasksConnection' ||
					allCompletedTasks.__typename !== 'PetitionTasksConnection'
				) {
					return;
				}
				const tasks = [...activeTasks.nodes, ...allCompletedTasks.nodes];
				const task = tasks.find((t) => t.name === taskId);
				if (task) {
					await completeTask(task.id, task.name);
					refreshData();
				}
			}
		},
		[isNextStepsEnabled, completeTask, activeTasks, allCompletedTasks, refreshData],
	);

	return handleAutoCheckOffTask;
}
